import { serviceDirectoryApiClient } from '@/services/service-directory';

class FeatureItem {
  fetchFeatureItem = async () => {
    const response = await serviceDirectoryApiClient.get('appFeatures');
    return response.data;
  };
}

export const FeatureItemInstance = new FeatureItem();
